import { FetchData } from "services/api";

function buildExcelExportUrl(route, params = {}) {
  const query = new URLSearchParams(params);
  const q = query.toString();
  return q ? `${route}?${q}` : route;
}

/** GET export Excel — réponse attendue en blob (`FetchData` file + blob). */
export const fetchExcelExportBlob = (route, params = {}) =>
  FetchData(
    buildExcelExportUrl(route, params),
    {
      method: "GET",
    },
    true,
    true,
  );
